
import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import Dashboard from "./Dashboard";
import ProductManagement from "./ProductManagement";
import Promotion from "./Promotion";
import SalesJimatshop from "./SalesJimatshop";
import SalesHistory from "./SalesHistory";
import OrderJimatbiz from "./OrderJimatbiz";
import JimatbizOrder from "./JimatbizOrder";
import AdvancedInventory from "./AdvancedInventory";
import LoyaltyProgramme from "./LoyaltyProgramme";
import CustomerManagement from "./CustomerManagement";
import AngkasaMember from "./AngkasaMember";
import VoucherManagement from "./VoucherManagement";
import SubsidyManagement from "./SubsidyManagement";
import EmployeeManagement from "./EmployeeManagement";
import KpiManagement from "./KpiManagement";
import PlanogramManagement from "./PlanogramManagement";
import Sales from "./Sales";
import POS from "./POS";
import POSv2 from "./POSv2";
import Profile from "./Profile";
import SyncProgress from "./SyncProgress";
import CustomerSearch from "./CustomerSearch";
import ProductSearch from "./ProductSearch";
import ViewAllOrders from "./ViewAllOrders";

const DashboardRoutes = () => {
  return (
    <DashboardLayout>
      <Routes>
        {/* POSv2 is set as the home page */}
        <Route path="/" element={<POSv2 />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/pos" element={<POS />} />
        <Route path="/posv2" element={<POSv2 />} />
        <Route path="/product-management" element={<ProductManagement />} />
        <Route path="/promotion" element={<Promotion />} />
        <Route path="/sales-jimatshop" element={<SalesJimatshop />} />
        <Route path="/sales-history" element={<SalesHistory />} />
        <Route path="/order-jimatbiz" element={<OrderJimatbiz />} />
        <Route path="/jimatbiz-order" element={<JimatbizOrder />} />
        <Route path="/advanced-inventory" element={<AdvancedInventory />} />
        <Route path="/loyalty-programme" element={<LoyaltyProgramme />} />
        <Route path="/customer-management" element={<CustomerManagement />} />
        <Route path="/angkasa-member" element={<AngkasaMember />} />
        <Route path="/voucher-management" element={<VoucherManagement />} />
        <Route path="/subsidy-management" element={<SubsidyManagement />} />
        <Route path="/employee-management" element={<EmployeeManagement />} />
        <Route path="/kpi-management" element={<KpiManagement />} />
        <Route path="/planogram" element={<PlanogramManagement />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/sync-progress" element={<SyncProgress />} />
        {/* Search pages */}
        <Route path="/customer-search" element={<CustomerSearch />} />
        <Route path="/product-search" element={<ProductSearch />} />
        <Route path="/view-all-orders" element={<ViewAllOrders />} />
      </Routes>
    </DashboardLayout>
  );
};

export default DashboardRoutes;
